import type { PropsWithChildren } from "react";
import { useFeatureFlag } from "posthog-react-native";

import { posthog } from "@/shared/lib/posthog";
import { MaintenanceScreen } from "./maintenance-screen";

function MaintenanceGateInner({ children }: PropsWithChildren) {
  const maintenanceFlag = useFeatureFlag("maintenance_mode");

  if (maintenanceFlag === true) {
    return <MaintenanceScreen />;
  }

  return <>{children}</>;
}

export function MaintenanceGate({ children }: PropsWithChildren) {
  if (!posthog) return <>{children}</>;
  return <MaintenanceGateInner>{children}</MaintenanceGateInner>;
}
